import { isLocal } from './isLocal';

const buildInstitutionURL = ({ baseUrl, subdomain = 'api', path = '' }) => {
  const host = window.location.hostname;
  const institution = process.env.INSTITUTION || 'mock'; // for unit test we use 'mock' instead
  const re = /([.])(?:(?=(\\?))\2.)*?\1/; // example: ssa.pa-core.aula.education
  const inst = isLocal
    ? `${institution}.`
    : host.match(re)[0].replace(/^\./, ''); // example pa-core.
  const fullSubdomain = subdomain ? `${subdomain}.` : '';
  const base = baseUrl || `https://${fullSubdomain}${inst}aula.education`;
  return `${base}/${path}`;
};

export default buildInstitutionURL;
